<template>
  <div class="no-avatar">
    <ds-iconfont
      icon-class="icon-mk-wx-user"
      :style="style"
    />
  </div>
</template>

<script>
export default {
  name: 'NoAvatar',
  props: {
    fontSize: {
      type: [String, Number],
      default: 16
    }
  },
  computed: {
    style () {
      return {
        fontSize: this.fontSize + 'px'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.no-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(230, 230, 230, 1);

  .icon-mk-wx-user {
    color: #fff;
  }
}
</style>
